<template>
  <div class="mt-4">
    <h1 class="mb-4 text-center">Flugbetrieb</h1>
    <b-row class="flight-operations-row">
      <b-col cols="6" md="4" lg="4" class="mt-2">
        <b-card class="tile text-center" @click="navigateToServiceBookOverall()">
          <b-icon icon="book" variant="danger" font-scale="2"></b-icon>
          <h5 class="mt-2">Dienstbuch</h5>
        </b-card>
      </b-col>

      <b-col cols="6" md="4" lg="4" class="mt-2">
        <b-card class="tile text-center" @click="navigateToGuestflightView()">
          <b-icon icon="people" variant="danger" font-scale="2"></b-icon>
          <h5 class="mt-2">Gästeflüge</h5>
        </b-card>
      </b-col>

      <b-col cols="6" md="4" lg="4" class="mt-2">
        <b-card class="tile text-center" @click="showServiceSchedule()">
          <b-icon icon="calendar-event" variant="danger" font-scale="2"></b-icon>
          <h5 class="mt-2">Dienstplan</h5>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: { },
  data() {
    return {
      currentDate: null,
      formattedDate: null,
      isActive: false,

      loading: false,

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {
    serviceBookCreateEntry() {
      this.$router.push("/flight-operations/service-book/new-entry");
    },

    serviceBookEditEntry() {
      this.$router.push("/flight-operations/service-book/edit-entry");
    },

    openServiceBookArchive() {
      this.$router.push("/flight-operations/service-book/archive");
    },

    navigateToGuestflightView() {
      this.$router.push("/flight-operations/guest-flight");
    },

    navigateToServiceBookOverall() {
      this.$router.push("/flight-operations/service-book/overall");
    },

    showServiceSchedule() {
      window.open('https://vereinsflieger.de/member/community/DownloadDocument?did=1028407', '_blank', 'noopener,noreferrer');
    },
  },

  beforeMount() {
    this.loading = true;

    axios
      .get(this.apiUrl + "/service-book/get-options")
      .then((response) => {
        this.currentDate = response.data.date.currentDate;
        this.formattedDate = response.data.date.formattedDate;

        this.isActive = response.data.isActive;

        this.loading = false;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);

        if (error.status === 401) {
          localStorage.removeItem("token");
        }
      });
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}

h1 {
  text-align: center;
}

.tile {
  padding-top: 15%;
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 10px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.tile:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

b-icon {
  margin-bottom: 8px;
}

h5 {
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  color: #333;
}

@media (min-width: 992px) {
  .flight-operations-row {
    margin: auto;
    width: 50%;
  }
}
</style>
